import { afterCartChangeType } from '@services/cart';
import { openMinicart } from '@components/minicart';

const CART_MUTATION_RE = /\/cart\/(add|update|change|clear)(\.js)?(\?|$)/;

const syncCart = (url) => {
  // the module-scope afterCartChange listener in @components/minicart takes
  // care of refreshing the drawer content (dBlank pattern); here we only
  // dispatch and, on add, open the drawer without a second fetch
  document.dispatchEvent(new CustomEvent(afterCartChangeType));
  if (/\/cart\/add/.test(url)) openMinicart();
};

/**
 * Gift Reggie (app proxy pages under /apps/giftregistry) mutates the cart
 * via the Ajax API without dispatching the theme's afterCartChange event,
 * leaving the header counter and minicart stale (BMBU-80). Observe fetch/XHR
 * cart mutations on those pages, re-dispatch the theme event and refresh
 * (or open, on add) the minicart.
 */
export const initExternalCartSync = () => {
  if (!window.location.pathname.includes('/apps/giftregistry')) return;

  const originalFetch = window.fetch;
  window.fetch = async (...args) => {
    const response = await originalFetch(...args);
    const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || args[0]?.href || '';
    if (response.ok && CART_MUTATION_RE.test(url)) syncCart(url);
    return response;
  };

  const originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    if (CART_MUTATION_RE.test(String(url)))
      this.addEventListener('load', () => {
        if (this.status >= 200 && this.status < 300) syncCart(String(url));
      });
    return originalOpen.call(this, method, url, ...rest);
  };
};
